<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="5">
              <el-date-picker
                v-model="yearflag" size="small"
                type="year"
                placeholder="选择年"
                @change="bindGrid">
              </el-date-picker>
            </el-col>
          </el-col>
        </div>

        <el-table
          :data="tableData"
          :height="tableheight"
          size="mini"
        show-summary
        :summary-method="getSummaries"
          border
          style="width: 100%;">
          <el-table-column label="人员" align="right" header-align="center" prop="uname">
          </el-table-column>
          <el-table-column label="总数" align="right" header-align="center" width="70" prop="ordernumber">
          </el-table-column>
          <el-table-column label="新增" align="right" header-align="center" width="60" prop="yearplus">
          </el-table-column>
          <el-table-column :label="item.name" v-for="item in coloum" :key="item.code" header-align="center">
          <el-table-column label="客户" align="right" header-align="center" width="40" >
            <template slot-scope="scope">{{scope.row['1'+item.code]}}</template>
          </el-table-column>
          <el-table-column label="业务" align="right" header-align="center" width="40">
            <template slot-scope="scope">{{scope.row['2'+item.code]}}</template>
          </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
  </div>
</template>
<script>

  import {totalDept} from '@/api/set/externaldept';


  export default {
    name: 'Externaldeptsub',
    data() {
      return {
        tableData: [],
        yearflag: '',//年份
        tableheight:300,
        independentserial: 'all',
        sum:[],
        coloum: [
          {name: '1月', code: '1',value1:0,value2:0},
          {name: "2月", code: '2',value1:0,value2:0},
          {name: "3月", code: '3',value1:0,value2:0},
          {name: "4月", code: '4',value1:0,value2:0},
          {name: "5月", code: '5',value1:0,value2:0},
          {name: "6月", code: '6',value1:0,value2:0},
          {name: "7月", code: '7',value1:0,value2:0},
          {name: "8月", code: '8',value1:0,value2:0},
          {name: "9月", code: '9',value1:0,value2:0},
          {name: "10月", code: '10',value1:0,value2:0},
          {name: "11月", code: '11',value1:0,value2:0},
          {name: "12月", code: '12',value1:0,value2:0}
        ],
      }
    },
    props: {
    },
    methods: {
      getSummaries(params){
        return this.sum;
      },
      bindGrid() {//绑定列表
        this.tableData = []
        this.sum=[]
        this.tableheight=300;
        var startDate = new Date(this.yearflag);
        totalDept({
          yearflag: startDate.getFullYear()
        }).then(response => {
          var data = response.data.obj
          for (var i in data) {
            if (data[i].paystyle) {
              var monthtotal = JSON.parse(data[i].paystyle);
              var sub=0;
              for (let key in monthtotal) {
                data[i][key] = monthtotal[key];
                sub+=parseInt(monthtotal[key]);
              }
              data[i]["yearplus"]=sub;//行合计
            }
          }

          var total=0;
          var yearplus=0;
          for(let i in this.coloum){
            this.coloum[i]["value1"]=0;
            this.coloum[i]["value2"]=0;
          }
          for(let i in data){
            total+=parseInt(data[i].ordernumber?data[i].ordernumber:0);
            yearplus+=parseInt(data[i].yearplus?data[i].yearplus:0);
            for(let j in this.coloum){
              this.coloum[j]["value1"]+=data[i]["1"+this.coloum[j].code]?parseInt(data[i]["1"+this.coloum[j].code]):0;
              this.coloum[j]["value2"]+=data[i]["2"+this.coloum[j].code]?parseInt(data[i]["2"+this.coloum[j].code]):0;
            }
          }
          this.sum.push("合计");
          this.sum.push(total);
          this.sum.push(yearplus);
          for(let i in this.coloum){
            this.sum.push(this.coloum[i]["value1"]);
            this.sum.push(this.coloum[i]["value2"]);
          }

          this.tableData=data;

          this.$nextTick(() => {
            this.tableheight = this.tableHeight(70);
          });
        }).catch((error) => {
          console.log(error)
        });
      },
    },

    mounted() {
      this.yearflag = new Date().getFullYear() + '-' + (new Date().getMonth() + 1)//当前年份
      this.bindGrid();
    },
    components: {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/Externaldeptsub.vue